import { render } from "./Landscapes.vue?vue&type=template&id=694a6d86"
import script from "./Landscapes.vue?vue&type=script&lang=js"
export * from "./Landscapes.vue?vue&type=script&lang=js"

import "./Landscapes.vue?vue&type=style&index=0&id=694a6d86&lang=scss"
import "./Landscapes.vue?vue&type=style&index=1&id=694a6d86&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/ddv-home/Landscapes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "694a6d86"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('694a6d86', __exports__)) {
    api.reload('694a6d86', __exports__)
  }
  
  module.hot.accept("./Landscapes.vue?vue&type=template&id=694a6d86", () => {
    api.rerender('694a6d86', render)
  })

}


export default __exports__